import React, { useState } from "react";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import DetailBox from "./DetailBox";
import { getExportCustomerVisit } from "../../actions/CustomerVisitAction";
import { getExportData } from "../../Common/functions";

const CustomerVisitOverview = ({
  data,
  loading,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  setSearchTerm,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "visitdate",
    "doctorsname",
    "product_discussed",
    "call_notes",
    "action",
  ]);
  const tableHeaders = [
    { label: "Date", value: "visitdate" },
    { label: "Doctor name", value: "doctorsname" },
    { label: "Products", value: "product_discussed" },
    { label: "Note", value: "call_notes" },
    { label: "Action", value: "action" },
  ];

  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);

  const handleExport = () => {
    console.log("Exporting data:", exportData);
  };

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };

  const exportData = getExportData(data, tableHeaders, visibleHeaders);

  return (
    <div className="px-0 sm:px-4">
      <SearchExportComponent
        exportFileName="CustomerVisit"
        onSearch={handleSearch}
        onExport={handleExport}
        // searchPlaceholder="Search"
        tablefields={tableHeaders}
        selectedHeaders={visibleHeaders}
        onHeadersChange={setVisibleHeaders}
        FilterOptionVisisbility={false}
        exportData={exportData}
      />
      <TableLayout
        data={data}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
      {openDetailBox && (
        <DetailBox
          handleClose={() => setOpenDetailBox(false)}
          selectedObject={selectedObject}
        />
      )}
    </div>
  );
};

export default CustomerVisitOverview;
